import React from 'react'
import {
  change as changeFieldValue, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DadosEmpresa from './DadosEmpresa';
import EnderecoEmpresa from './EnderecoEmpresa';
import PessoasEmpresa from './PessoasEmpresa';


export class ModalCadastrarEmpresa extends React.Component {
  constructor(props) {
    super(props);
    this.proximaPagina = this.proximaPagina.bind(this);
    this.paginaAnterior = this.paginaAnterior.bind(this);
    this.fechar = this.fechar.bind(this);
    this.state = { paginaAtual: 1, arquivo: null };
  }

  fechar() {
    this.setState({ paginaAtual: 1 });
    this.limparFormulario();
    this.props.selecionarEmpresa(null);
    this.props.limparIntegracaoSelecionada();
    this.props.handleCheckedRegraConexaoTrecho(true);
  }

  limparFormulario() {
    this.props.destroy();
    this.props.reset('formularioCadastroUsuario');
    this.setState({ perfisSelecionados: [] });
    this.props.selecionarOrigem(null);
    this.props.selecionarOrigem(null);
    this.props.limparSitesSelecionados();
  }


  proximaPagina() {
    this.setState({ paginaAtual: this.state.paginaAtual + 1 })
  }

  paginaAnterior() {
    this.setState({ paginaAtual: this.state.paginaAtual - 1 })
  }

  adicionaArquivo(file) {
    this.setState({ arquivo: file })
  }

  removeArquivo() {
    this.setState({ arquivo: null })
  }

  exibePaginaAtual() {
    if (this.state.paginaAtual === 1) {
      return <DadosEmpresa
        onSubmit={this.proximaPagina}
        selecionarSite={this.props.selecionarSite}
        removerSite={this.props.removerSite}
        sitesSelecionados={this.props.sitesSelecionados}
        adicionaArquivo={this.adicionaArquivo.bind(this)}
        removeArquivo={this.removeArquivo.bind(this)}
        limparCampos={this.fechar.bind(this)}
        grupos={this.props.grupos}
        paginaAnterior={this.paginaAnterior}
        empresa={this.props.empresa}
        integracaoSelecionada={this.props.integracaoSelecionada}
        adicionarIntegracao={this.props.adicionarIntegracao}
        removerIntegracao={this.props.removerIntegracao}
        handleCheckIntegracaoAtiva={this.props.handleCheckIntegracaoAtiva}
        habilitadoRegraConexaoTrecho={this.props.habilitadoRegraConexaoTrecho}
        handleCheckedRegraConexaoTrecho={this.props.handleCheckedRegraConexaoTrecho}
        pagamentosDesativadosSelecionados={this.props.pagamentosDesativadosSelecionados}
        adicionarPagamentoDesativado={this.props.adicionarPagamentoDesativado}
        removerPagamentosDesativados={this.props.removerPagamentosDesativados}
      />
    }
    if (this.state.paginaAtual === 2) {
      return <EnderecoEmpresa
        paginaAnterior={this.paginaAnterior}
        selecionarOrigem={this.props.selecionarOrigem}
        cidade={this.props.cidade}
        proximaPagina={this.proximaPagina}
        limparCampos={this.fechar.bind(this)} />
    }
    if (this.state.paginaAtual === 3) {
      return <PessoasEmpresa
        paginaAnterior={this.paginaAnterior}
        proximaPagina={this.proximaPagina}
        montarParametroEmpresa={this.props.montarParametroEmpresa}
        arquivo={this.state.arquivo}
        buscarEmpresas={this.props.buscarEmpresas}
        limparCampos={this.fechar.bind(this)} />
    }
  }

  render() {
    const ehEdicao = this.props.empresa && this.props.empresa.id ? true : false;
    return (
      <div className="modal fade show" id='modalCadastrarEmpresa' role='dialog'
        aria-labelledby='modalCadastrarEmpresa' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>{ehEdicao ? 'Editar Empresa' : 'Nova Empresa'}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                onClick={() => this.fechar()}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            {this.exibePaginaAtual()}
          </div>
        </div>
      </div>
    )
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue
  }, dispatch)
);

export default connect(mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroEmpresa',
})(ModalCadastrarEmpresa));
